module.exports = __webpack_public_path__ + "static/event2019-07b2892bfbbbfb53fb62c629e5be6d3a.jpg";